// extracted by mini-css-extract-plugin
module.exports = {"bb-collapsed-text":"bb-collapsed-text__SReTB"};